import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, /* @__PURE__ */ e.createElement("path", { d: "m23.454 42.333-11.12-11.12-3.787 3.76L23.453 49.88l32-32-3.76-3.76z" }));
export {
  a as default
};
